import React, { useEffect, useState } from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import axiosInstance from "../utils/axiosInstance";

export default function PaymentSuccessPage() {
  const { token } = useParams();
  const [searchParams] = useSearchParams();

  const sessionId = searchParams.get("session_id");

  const [loading, setLoading] = useState(true);
  const [orderId, setOrderId] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const verifyPayment = async () => {
      if (!sessionId) {
        setError("Missing payment session.");
        setLoading(false);
        return;
      }

      try {
        const res = await axiosInstance.get(
          `/api/payments/order/remaining-success?session_id=${sessionId}`
        );

        if (res.data.success) {
          setOrderId(res.data.orderId);
        } else {
          setError("Payment verification failed.");
        }
      } catch (err) {
        console.error("❌ Verification error:", err);
        setError("Server error — payment could not be verified.");
      } finally {
        setLoading(false);
      }
    };

    verifyPayment();
  }, [sessionId]);

  if (loading) {
    return (
      <div className="p-6 text-center text-gray-600 text-lg">
        Verifying payment…
      </div>
    );
  }

  if (error) {
    return (
      <div className="max-w-lg mx-auto mt-10 bg-white p-6 rounded-xl shadow text-center">
        <h1 className="text-2xl font-bold text-red-600 mb-4">
          Payment Error
        </h1>
        <p className="text-gray-700 mb-4">{error}</p>

        <Link
          to={`/order/${token}/pay`}
          className="text-candy-primary underline"
        >
          Try Again
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-lg mx-auto mt-12 bg-white p-6 rounded-xl shadow text-center">
      <h1 className="text-3xl font-bold text-green-600 mb-4">
        🎉 Payment Successful!
      </h1>

      <p className="text-lg text-gray-700 mb-4">
        Thank you! Your remaining balance has been paid.
      </p>

      <div className="bg-gray-100 p-4 rounded-lg mb-6">
        <p className="text-gray-800">
          <strong>Order ID:</strong> {orderId}
        </p>
        <p className="text-gray-800 mt-1">
          Your order is now fully paid and confirmed.
        </p>
      </div>

      <Link
        to="/"
        className="bg-candy-primary hover:bg-candy-primaryDark text-white px-6 py-3 rounded-lg font-semibold transition"
      >
        Return to Home
      </Link>
    </div>
  );
}
